
export default {
  isFetching(state){
    return state.api.get.fetching;
  },
  getData(state){
    return state.api.get.values;
  },
}
